import { Typography } from '@material-ui/core';
import { useEffect } from 'react';
import AuthService from 'services/AuthService';
import styles from './Login.module.css';
import { useTranslation } from 'react-i18next';
const Login = (props) => {
  useEffect(() => {
    props?.locale ? AuthService.doLogin(props?.locale) : AuthService.doLogin();
  }, []);
  const { t } = useTranslation();

  return (
    <div className={styles.mainContainer}>
      <Typography component='h1' variant='h1' className={styles.mainText}>
        {t('login.moment')}
      </Typography>
      <Typography component='h2' variant='h2' className={styles.secondaryText}>
        {t('login.redirect')}
      </Typography>
    </div>
  );
};

export default Login;
